import * as React from 'react'
import tw from 'tailwind-styled-components'

const TwHeader = tw.div`
  flex
  items-center
  h-32
`

const TwTitle = tw.div`
  text-primary
  text-sm-semibold
  cursor-default
`

const TwContentContainer = tw.div`
  flex
  items-center
  gap-16
  ml-auto
`

export interface HeaderProps {
  children: string
  rightContent?: React.ReactNode
  className?: string
}

export const SharedHeader = (props: HeaderProps) => {
  const {children, rightContent, className} = props
  return (
    <TwHeader className={className}>
      <TwTitle>{children}</TwTitle>
      {rightContent && <TwContentContainer>{rightContent}</TwContentContainer>}
    </TwHeader>
  )
}
